export class ResponsesQuestion{

    RespuestaActivaSubPregunta;
    RespuestaId;
    RespuestaOrden;
    RespuestaTexto;
    RespuestaTipo;
    SubPreguntaId;

}